export const ACTIVATE_TRADING_DATA = 'page/TRADING_DATA [activate]';
export const LEAVE_TRADING_DATA = 'page/TRADING_DATA [leaving]';

export const TRADING_DATA_DATA = 'page/TRADING_DATA_DATA [done]';
export const TRADING_DATA_UPLOADED_DOCOUMENTS =
    'page/TRADING_DATA_UPLOADED_DOCOUMENTS';
export const TRADING_DATA_DATA_LOADING = 'page/TRADING_DATA_DATA [loading]';

export const SET_TRADING_DATA_LINKED_ACCOUNTS =
    'page/SET_TRADING_DATA_LINKED_ACCOUNTS';
export const UNLINK_LINKED_ACCOUNT = 'page/UNLINK_LINKED_ACCOUNT';
export const SET_UNLINKING_ACCOUNT = 'page/SET_UNLINKING_ACCOUNT';
export const CONFIRM_UNLINKING_ACCOUNT = 'page/CONFIRM_UNLINKING_ACCOUNT';
export const UNLINKING_ACCOUNT_SUCCESS = 'page/UNLINKING_ACCOUNT_SUCCESS';
export const UNLINKING_ACCOUNT_FAIL = 'page/UNLINKING_ACCOUNT_FAIL';
